export default "__VITE_ASSET__C4cwbo9H__"